<template>
  <div>
    <nav-header />
    <el-dialog :visible.sync="dialogVisible">
      <img max-width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  <div class="post-publish">
    <div class="wrapper">
    <div class="main">
    <!-- 内容输入区 -->
    <el-card class="content-card">
      <el-button type="primary" @click="publish" :loading="loading">发布</el-button>
      <el-form ref="form" :model="formData" :rules="rules">
        <!-- 编辑器切换 -->
        <div class="editor-switch">
          <el-radio-group v-model="editorType" size="small">
            <el-radio-button label="rich">富文本编辑器</el-radio-button>
            <el-radio-button label="plain">纯文本编辑器</el-radio-button>
          </el-radio-group>
        </div>
        <el-form-item v-show="editorType === 'rich'" label="标题" prop="title">
          <el-input v-model="formData.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <!-- 文本输入 -->
        <el-form-item prop="content">
          <!-- 富文本编辑器 -->
          <wangeditor 
            v-if="editorType === 'rich'" 
            @contentChange="onChange"
            @onCreated="onCreated"
            ref="editor"
          ></wangeditor>
          
          <!-- 纯文本编辑器 -->
          <el-input
            v-else
            type="textarea"
            v-model="formData.content"
            :rows="6"
            placeholder="分享你的想法..."
            :maxlength="2000"
            show-word-limit
          />
        </el-form-item>

        <!-- 图片上传 -->
        <el-form-item>
          <el-upload
              :action="action"
            list-type="picture-card"
            :on-success="handleImageSuccess"
            :on-remove="handleImageRemove"
            :limit="9"
            :file-list="imageList"
              :show-file-list="true"
            accept="image/*"
          >
            <i class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
              >
              <span class="el-upload-list__item-actions">
              <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
                <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                >
          <i class="el-icon-delete"></i>
        </span>
      </span>
            </div>
            <div slot="tip" class="el-upload__tip">封面：最多上传9张图片</div>
          </el-upload>
          <el-button @click="getCover">获取文件略缩图</el-button>
        </el-form-item>

        <!-- 文件上传 -->
        <el-form-item v-if="fileList.length>0">
          <el-upload
            class="file-upload"
            :action="action"
            :drag="true"
            :on-success="handleFileSuccess"
            :on-remove="handleFileRemove"
            :limit="5"
            :file-list="fileList"
            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.zip,.rar,.7z"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip">
              支持doc、xls、pdf等格式,单个文件不超过20MB,最多上传5个文件
            </div>
          </el-upload>
        </el-form-item>
        <h5>附件：</h5>
        <file-manager :bus-id="id" v-if="id" :parent-id="post.circleId"  ></file-manager>
        <file-manager v-else
          ref="fileManager"
          :need-late-binding="true"
          :parent-id="circleId"
           :bus-id="tempBusId"
            @fileList="managerFile"
        ></file-manager>
        <!-- 频道选择 -->
        <el-form-item prop="channelId">
          <el-select 
            v-model="formData.channelId" 
            placeholder="请选择频道"
            style="width: 200px"
          >
            <el-option
              v-for="item in channels"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 底部按钮 -->
    <div class="action-bar">
      <el-button type="primary" @click="publish" :loading="loading" >发布</el-button>
    </div>
    </div>
    <div class="circle-sidebar">
      <el-card class="circle-info-card">
        <!-- 圈子基本信息 -->
        <div class="circle-header">
          <el-avatar :size="60" :src="circleInfo.avatar" @click="goCircle"/>
          <div class="circle-meta">
            <h3 class="circle-name" @click="goCircle">{{circleInfo.name}}</h3>
            <div class="circle-stats">
              <span><i class="el-icon-user"></i>{{circleInfo.memberCount}}成员</span>
              <span><i class="el-icon-document"></i>{{circleInfo.postCount}}帖子</span>
            </div>
          </div>
        </div>

        <!-- 圈子简介 -->
        <div class="circle-desc">
          <div class="desc-title">圈子简介</div>
          <div class="desc-content">{{circleInfo.description || '暂无简介'}}</div>
          <div class="desc-item" v-if="circleInfo.joinType === 1">
            <span class="label">加入费用:</span>
            <span class="value">¥{{circleInfo.price}}</span>
          </div>
          <div class="desc-item">
            <span class="label">创建时间:</span>
            <span class="value">{{circleInfo.createTime}}</span>
          </div>
        </div>
      </el-card>

      <!-- 热门帖子 -->
      <el-card class="hot-posts-card" v-if="lastPosts.length>0">
        <div slot="header" class="card-header">
          <span>最近帖子</span>
        </div>
        <div class="hot-post-list">
          <div v-for="post in lastPosts"
               :key="post.id"
               class="hot-post-item"
               >
            <div class="post-title">{{post.title || post.content}}</div>
            <div class="post-meta">
              <span><i class="el-icon-chat-dot-round"></i>{{post.commentCount}}</span>
              <span><i class="el-icon-star-off"></i>{{post.likeCount}}</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    </div>
  </div>
  </div>
</template>

<script>
import Wangeditor from "@/components/editor/wangeditor.vue";
import FileManager from "@/components/FileManager/index.vue";
import { updateFile } from '@/api/file'
import NavHeader from "@/components/layout/NavHeader.vue";

export default {
  name: 'PostPublish',
  components: {NavHeader, FileManager, Wangeditor},
  props: {
    id: {
      type: [String, Number],
      required: false
    },
    post: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      circleId:'',
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      formData: {
        id: '',
        title: '',
        content: '',
        channelId: '',
        images: [],
        files: [],
        excerpt: ''
      },
      imageList: [],
      fileList: [],
      channels: [],
      rules: {
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      editorType: 'plain',
      tempBusId:  Date.now(), // 生成临时ID
      uploadedFiles: [], // 存储上传的文件ID,
      circleInfo:{},
      lastPosts:[],
      loading:false,
      dialogImageUrl : '',
      dialogVisible : false
    }
  },
  created() {
    if(this.$route.query.circleId){
      this.circleId=this.$route.query.circleId;
    }
    if(this.$route.query.id) {
      this.id=this.$route.query.id
      this.loadPost()
    }else {
      this.loadChannels()
      this.loadPosts();
    }
  },

  watch: {
    // 监听编辑器类型变化
    editorType(newType) {
      if (newType === 'plain') {
        // 从富文本切换到纯文本时,去除HTML标签
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = this.formData.content
        this.formData.content = tempDiv.textContent || tempDiv.innerText
        this.formData.excerpt='';
      }
    }
  },

  methods: {
    // 加载帖子详情
    async loadPost() {
      try {
        const res = await this.$http2({
          url: `/klgeek/postDeatil/${this.id}`,
          method: 'GET'
        })
        this.post = res.data
        this.initEditData();
        this.loadChannels()
        this.loadPosts();
      } catch(e) {
        console.error(e)
      }
    },
    handleRemove(file) {
      this.imageList=this.imageList.filter(item => item.url!== file.url);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    managerFile(fileList){
      console.log("当前文件列表",fileList)
      fileList.forEach((element)=>{
        if(!element.isFolder && element.thumb)
        this.imageList.push({url:element.thumb})
      })
    },
    getCover(){
      this.$refs.fileManager.getFileList();
    },
    // 加载帖子列表
    async loadPosts() {
      try {
        const res = await this.$http2({
          url: '/klgeek/postList',
          params: {
            circleId: this.circleId,
            pageSize: 5,
          }
        })
        this.lastPosts = res.rows
      } catch(e) {
        console.error(e)
      }
    },
    // 跳转到圈子页面
    goCircle() {
      this.$router.push({ name: 'postList', params: { id: this.circleId } })
    },

    // 初始化编辑数据
    initEditData() {
      console.log(this.post)
      this.formData = {
        id: this.post.id,
        title: this.post.title,
        content: this.post.content,
        channelId: this.post.channelId,
        images: [],
        files: [],
        excerpt: this.post.excerpt
      }
      this.circleId=this.post.circleId;
      // 初始化图片列表
      if(this.post.images) {
        const images = JSON.parse(this.post.images)
        this.imageList = images.map(url => ({
          url,
          response: { data: { originUrl: url } }
        }))
      }
      
      // 初始化文件列表
      if(this.post.files) {
        const files = JSON.parse(this.post.files)
        this.fileList = files.map(file => ({
          name: file.name,
          url: file.url,
          size:file.size,
          response: { data: { originUrl: file.url } }
        }))
      }
      
      // 设置编辑器类型
      this.editorType = this.post.title ? 'rich' : 'plain'
    },
    onCreated(editor){
        if(this.post?.title)
          editor.setHtml(this.post.content)
    },
    onChange(editor){
      this.formData.content= editor.getHtml();
      this.formData.excerpt=editor.getText();
    },
    // 加载频道列表
    async loadChannels() {
      try {
        const res = await this.$http2({
          url: `/klgeek/circle/${this.circleId}`,
          method: 'GET'
        })
        this.channels = res.data.channels
        this.circleInfo=res.data;
      } catch(e) {
        console.error(e)
      }
    },

    // 图片上传成功
    handleImageSuccess(res, file,fileList) {
      console.log(fileList)
      // this.formData.images.push(res.data.originUrl)
      this.imageList=fileList;
    },

    // 删除图片
    handleImageRemove(file, fileList) {
      console.log(fileList)
      this.imageList=fileList;
    },

    // 文件上传成功
    handleFileSuccess(res, file,fileList) {
      this.fileList=fileList;
    },

    // 删除文件
    handleFileRemove(file, fileList) {
      console.log(fileList)
      this.fileList=fileList;
    },

    // 取消发布
    cancel() {
      this.$router.back()
    },

    // 处理文件上传完成事件
    handleFileUploaded(fileInfo) {
      this.uploadedFiles.push(fileInfo.id)
    },

    // 发布帖子
    async publish() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if(this.editorType=='rich' && !this.formData.title){
          this.$message.error('标题不能为空')
          return
        }
        this.imageList.forEach((element, index) => {
          if(element.response){
            this.formData.images.push(element.response.data.originUrl)
          }else{
            this.formData.images.push(element.url)
          }
        });
        this.fileList.forEach((element, index) => {
          this.formData.files.push({
            name: element.name,
            size: element.size,
            url: element.response.data.originUrl,
            id: element.response.data.originUrl.split('/').pop(),
            type: element.name.split('.').pop().toLowerCase()
          })
        });
        try {
          // 保存帖子
          this.loading=true;
          const response = await this.$http2({
            url:  '/klgeek/post',
            method: this.formData.id ? 'PUT' : 'POST',
            data: {
              circleId: this.circleId,
              ...this.formData
            }
          })
          this.$message.success(this.formData.id ? '更新成功' : '发布成功');
          // 更新文件管理器中的业务ID
          if(this.$refs.fileManager)
          await this.$refs.fileManager.updateBusId(response.data)
            this.$router.push(`/post-list/${this.circleId}`)
        } catch(e) {
          console.error(e)
        }finally {
          this.loading=false;
        }
      })
    },
    
    // 更新文件的业务ID
    async updateFilesBusId(fileIds, busId) {
      for (const fileId of fileIds) {
        await updateFile({
          id: fileId,
          busId: busId
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  gap: 20px;
  position: relative;
}
.main {
  flex: 1;
  min-width: 0;
}
.circle-sidebar {
  width: 300px;
  flex-shrink: 0;  // 防止侧边栏被压缩

  .circle-info-card {
    margin-bottom: 20px;

    .circle-header {
      display: flex;
      gap: 16px;
      margin-bottom: 16px;

      .circle-meta {
        flex: 1;
        min-width: 0;

        .circle-name {
          font-size: 18px;
          margin: 0 0 8px;
          cursor: pointer;

          &:hover {
            color: #409EFF;
          }
        }

        .circle-stats {
          display: flex;
          gap: 16px;
          color: #666;
          font-size: 14px;

          i {
            margin-right: 4px;
          }
        }
      }
    }

    .circle-desc {
      padding: 15px 0;
      border-top: 1px solid #f0f0f0;

      .desc-title {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 12px;
        color: #333;
      }

      .desc-content {
        color: #666;
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 15px;
      }

      .desc-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          color: #999;
          margin-right: 8px;
        }

        .value {
          color: #666;
          &.price {
            color: #ff6b00;
            font-weight: 500;
          }
        }
      }
    }
  }

  .hot-posts-card {
    .card-header {
      font-weight: 500;
    }

    .hot-post-list {
      .hot-post-item {
        padding: 12px 0;
        border-bottom: 1px solid #eee;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          .post-title {
            color: #409EFF;
          }
        }

        .post-title {
          font-size: 14px;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .post-meta {
          display: flex;
          gap: 16px;
          color: #999;
          font-size: 12px;

          i {
            margin-right: 4px;
          }
        }
      }
    }
  }
}
.post-publish {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  .content-card {
    margin-bottom: 20px;
  }

  .file-upload {
    .el-upload-list {
      max-height: 300px;
      overflow-y: auto;
    }
  }

  .action-bar {
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .editor-switch {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style> 